<template>
  <div class="textArea">
    <h3>経験のある技術（特に注力していた時期）</h3>

    <h4>Python (2017-)</h4>
    一番書いてます。
    <ul>
      <li>NumPy</li>
      <li>SciPy</li>
      <li>OpenCV</li>
      <li>Scikit-learn</li>
      <li>Tensorflow (Tensorflow.keras)</li>
      <li>Flask</li>
    </ul>

    <h4>サーバサイドNode.js (2019-)</h4>
    <ul>
      <li>express</li>
      <li>MongoDB/Mongoose</li>
    </ul>

    <h4>webフロントエンド (2020)</h4>
    趣味ですが、本サイトの構築に使用しています。
    <ul>
      <li>静的html+js+cssコンテンツのホスティング</li>
      <li>Vue.js</li>
      <li>Vue-CLI</li>
    </ul>

    <h4>C++ (2018)</h4>
    <ul>
      <li>Arduino互換機開発（ESP32、M5シリーズ）</li>
    </ul>

    <h4>C# (2018)</h4>
    <ul>
      <li>WPF</li>
      <li>Unity（少しだけ）</li>
    </ul>

    <h4>fortran (2012-2018)</h4>
    <ul>
      <li>MPI</li>
      <li>OpenMP</li>
    </ul>

    <h4>ゲームエンジン、3Dモデリング (2018-)</h4>
    どれも簡単な操作のみ
    <ul>
      <li>Unity</li>
      <li>Unreal Engine 4</li>
      <li>meshlab</li>
      <li>blender</li>
    </ul>

    <h4>LaTeX (2017-)</h4>
    論文執筆に使用。

    <h4>bash (2016～2017)</h4>
    <ul>
      <li>awk</li>
      <li>gnuplot</li>
    </ul>

    <h4>その他開発ツール</h4>
    <ul>
      <li>Docker</li>
      <li>Git</li>
      <li>GitHub ActionsによるCI/CD</li>
      <li>VSCode</li>
      <li>Emacs（CUIも可能）</li>
      <li>SSH</li>
      <li>RaspberryPi</li>
      <li>VirtualBox</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Skills",
};
</script>

<style scoped>
div.textArea {
  background: #ffffff;
  text-align: left;
  vertical-align: top;
  padding: 10px;
  margin: 10px 0px 10px 0px;
}
</style>